import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web"
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const DrawingOnMapTag = ({show}) => {
    if (!show) return null;
    
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();

    const handleCleanFilter = () => {
        const valuesToReset = {
            map_polygons: null
        }

        changeFilters(valuesToReset)
    }

    return (
        <div className="inputFilterBox active">
            <div className="inputFilterBox__label">
                <p>Dibujo en mapa</p>

                <button className="inputFilterBox__label--reset" onClick={handleCleanFilter}>
                    <CloseIcon width={12} />
                </button>
            </div>
        </div>
    )
}